export const DEBOUNCE_DELAY = {
  DEFAULT: 500,
  FORM_AUTOSAVE: 500,
  DIALOG_OPEN: 300,
  INPUT_RESET: 2500,
};
